export default __webpack_public_path__ + "assets/ground-systems.5005f099.jpg";